import React, {useCallback} from "react";
import {t, Trans} from '@lingui/macro';
import {withI18n} from "@lingui/react";
import {Button, Checkbox, Col, Form, Row} from 'antd';
import Drawer from 'bukku/components/Ant/Drawer';
import {connect} from "react-redux";
import LocalStorageActions from "bukku/redux/LocalStorage/actions";

const { selectColumns } = LocalStorageActions;

/**
 * Props:
 * - visible: Boolean
 * - closeDrawer: Function, called when drawer is close
 * - storageKey: StorageKey
 */

function CustomizeColumnDrawer(props) {
    const { storageKey, visible, closeDrawer, options } = props; // parent
    const { selected, selectColumns } = props; // redux

    const selectedTotal = selected.length;
    const optionTotal = options.length;
    const requiredTotal = options.filter(opt => opt.disabled).length;

    const onChange = useCallback(values => {
        selectColumns(storageKey, values);
    }, [selectColumns, storageKey]);

    const checked = selectedTotal === optionTotal;

    const indeterminate = (
        selectedTotal > requiredTotal &&
        selectedTotal < optionTotal
    );

    const onSelectAll = useCallback(() => {
        // Has not selected all --> Selecting will enable all
        if (!checked)
            return onChange(options.map(option => option.value));

        // Has selected all --> Selecting will only check required options
        return onChange(options.filter(option => option.disabled).map(option => option.value));
    }, [checked, onChange, options]);

    return (
        <Drawer
            title={<Trans>Select Columns</Trans>}
            placement="right"
            closable
            onClose={closeDrawer}
            open={visible}
            destroyOnClose
            footer={
                <Button onClick={closeDrawer} type="primary" htmlType="submit">
                    <Trans>Close</Trans>
                </Button>
            }
            onClick={e => e.stopPropagation()}
        >
            <Checkbox
                indeterminate={indeterminate}
                onChange={onSelectAll}
                checked={checked} // fully checked
            >
                <Trans>View All Columns</Trans>
            </Checkbox>
            <hr color="#fafafa" />
            <Form layout="vertical" className="input-form">
                <Row
                    type="flex"
                    gutter={12}
                >
                    <Col span={24}>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: t`Please select at least one column.`,
                                },
                            ]}
                        >
                            <Checkbox.Group
                                className="vertical"
                                onChange={onChange}
                                value={selected}
                                options={options}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Drawer>
    );
}

export default connect((state, props) => ({
    // fields: state.List.fields,
    selected: (state.LocalStorage[props.storageKey]?.columns || []).map(column => column.key),
    // companyCurrencyCode: state.Auth.companyCurrencyCode,
}), {
    selectColumns,
})(withI18n()(CustomizeColumnDrawer));
